<template>
    <div class="user-navbar" v-if="profile">
			<ul v-if="isVertical" class="nav-components_font p-l-md">
				<li><router-link :to='`/view/${profile.profile_id}/about`'>ABOUT</router-link></li>
				<li><router-link :to='`/view/${profile.profile_id}/activities`'>ACTIVITIES</router-link></li>
				<li><router-link :to='`/view/${profile.profile_id}/articles`'>ARTICLES</router-link></li>
				<li v-if="this.$store.getters.isStoreAvailable"><router-link :to='`/view/${profile.profile_id}/products`'>PRODUCTS</router-link></li>
				<li><router-link :to='`/view/${profile.profile_id}/events`'>EVENTS</router-link></li>
				<li><router-link :to='`/view/${profile.profile_id}/media`'>MEDIA</router-link></li>
				<li><router-link :to='`/view/${profile.profile_id}/members`'>MEMBERS</router-link></li>
				<!--<router-link to="careers" tag="li"><a class="text-muted">CAREERS</a></router-link>-->
			</ul>
			<ul v-if="!isVertical" class="nav nav-tabs nav-components b-t b-b scroll">
				<router-link :to='`/view/${profile.profile_id}/about`' tag="li"><a class="text-u-c nav-components_font">about</a></router-link>
				<router-link :to="`/view/${profile.profile_id}/activities`" tag="li"><a class="text-u-c nav-components_font">activities</a></router-link>
				<router-link :to="`/view/${profile.profile_id}/articles`" tag="li"><a class="text-u-c nav-components_font">articles</a></router-link>
				<router-link v-if="this.$store.getters.isStoreAvailable" :to="`/view/${profile.profile_id}/products`" tag="li"><a class="text-u-c nav-components_font">products</a></router-link>
				<router-link :to="`/view/${profile.profile_id}/events`" tag="li"><a class="text-u-c nav-components_font">events</a></router-link>
				<router-link :to="`/view/${profile.profile_id}/media`" tag="li"><a class="text-u-c nav-components_font">media</a></router-link>
				<router-link :to="`/view/${profile.profile_id}/members`" tag="li"><a class="text-u-c nav-components_font">members</a></router-link>
				<!--<router-link to="careers" tag="li"><a class="text-muted">careers</a></router-link>-->
			</ul>
    </div>
</template>

<script>
export default {
  data() {
    return {
      routing: null
    }
  },
	props: {
		isVertical: {
			default: true
		}
	},
	computed:{
		profile(){
			return this.$store.getters.profile;
		}
	},
}
</script>

<style lang="scss">
  .user-navbar ul li {
    color: #888;
    font-weight: 400 !important;
    &:hover {
      font-weight: 300 !important;
    }
    .active {
      font-weight: 300 !important;
    }
  }
</style>

<style>

@media only screen and (min-width: 1200px) {
	.nav-components_font {
		font-family: Roboto;
		font-weight: normal;
		font-size: 16px;
		line-height: 19px;
		color: #7d7d7d;
		padding-top: 15px;
	}
}

@media only screen and (max-width: 1023px) and (min-width: 768px) {
	.nav-components_font {
		font-family: Roboto;
		font-weight: 400;
		font-size: 16px;
		line-height: 19px;
		color: #7d7d7d;
	}
	.user-navbar ul li a.active {
    font-weight: 300;
	}

}

@media screen and (max-width: 767px) {
	.nav-components_font {
		font-family: Roboto;
		font-weight: 400;
		font-size: 10px;
		line-height: 12px;
		text-align: center;
		color: #888888;
	}
	.nav-components>li.active>a {
		color: #000 !important;
	}
}

@media screen and (max-width: 578px) {
	.scroll {
		overflow-x: scroll;
		overflow-y: hidden;
		white-space: nowrap;
	}
	.scroll .text-muted{
		display: inline-block;
	}
}
</style>
